import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyC6i5QVcNSsIDO3kOUlHOw3eADjIMOwmPE',
  authDomain: 'sortmyprep-5102b.firebaseapp.com',
  projectId: 'sortmyprep-5102b',
  storageBucket: 'sortmyprep-5102b.firebasestorage.app',
  messagingSenderId: '785099272006',
  appId: '1:785099272006:web:93ba3593bd3a335c56ff47',
  measurementId: 'G-WNE9BGCME5',
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };
